import React, {useCallback} from 'react';

export const useDropPreset = (effect) => {
    const onDropPreset = useCallback((e) => {
        e.stopPropagation();
        let presetDragging = effect.track.sequencerEngine.state.presets.presetDragging;
        if (presetDragging) {
            effect.dropPreset(presetDragging);
        }
    }, [effect]);

    return {onDropPreset};
};
